<template>
<div>
  <div class="row">
    <div class="col-lg-12">
      <div class="wrapper wrapper-content animated fadeInUp">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Keyword lists</h5>
            <div class="ibox-tools">
              <a href="" class="btn btn-primary btn-xs">Add new</a>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Country</th>
                  <th>Keywords</th>
                  <th>Added</th>
                  <th>Last Update</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="country in countries" :key="country.country">
                  <td>{{ country.country }}</td>
                  <td>{{ country.count }}</td>
                  <td>{{ $moment(country.updated.date).format('DD.MM.YYYY HH:mm') }}</td>
                  <td>{{ country.lastUpdate || '/' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CountryKeywords',
  data () {
    return {
      name: 'CountryKeywords',
      countries: []
    }
  },
  mounted () {
    this.getKeywordSummary()
  },
  methods: {
    getKeywordSummary () {
      axios.get('/am/seo/keywords-country')
        .then(r => {
          this.countries = r.data.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Seo/CountryKeywords.vue